import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages";
import Footer from "../src/components/Footer/";
import { Analytics } from "@vercel/analytics/react";
import Error404 from "./pages/not-found";
import Aboutpage from "./pages/aboutpage";
import Skillspage from "./pages/skillspage";
import Projectspage from "./pages/projectspage";
import Reparacionespage from "./pages/Reparacionespage";
// import Blogpage from "./pages/Blogpage";
// import BlogLoginPage from "./pages/BlogLoginPage";
// import BlogRegisterPage from "./pages/BlogRegisterPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/sobre-mi" element={<Aboutpage />} />
          <Route path="/tecnologias" element={<Skillspage />} />
          <Route path="/proyectos" element={<Projectspage />} />
          <Route path="/reparacion-de-PC" element={<Reparacionespage />} />

          {/* <Route path="/blog" element={<Blogpage />} />
          <Route path="/iniciar-sesion" element={<BlogLoginPage />} />
          <Route path="/registrarse" element={<BlogRegisterPage />} /> */}
          <Route path="*" element={<Error404 />} />
        </Routes>
        <Footer />
        <Analytics />
      </BrowserRouter>
    </div>
  );
}

export default App;
